import { combineEpics } from "redux-observable";
import {
  FETCH_STATS_COMBINED_SCORES,
  fetchStatsCombinedScoresSuccess,
  fetchStatsCombinedScoresFailed,
} from "../actions";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import ScoresApi from "../../../services/scores-api";

export const fetchStatsCombinedScores = (action$) =>
  action$
    .pipe(ofType(FETCH_STATS_COMBINED_SCORES))
    .pipe(switchMap(({ payload }) => getGolferScores(payload)));

const getGolferScores = (payload) =>
  from(
    ScoresApi.getGolferScores(
      parseInt(payload.ghinNumber, 10),
      payload.onlyStats,
      payload.extraParams
    )
  )
    .pipe(map((response) => fetchStatsCombinedScoresSuccess(response.data)))
    .pipe(catchError((error) => of(fetchStatsCombinedScoresFailed(error))));

export default combineEpics(fetchStatsCombinedScores);
